<template>
    <li class="summary-segment-item">
        <div class="summary-segment-item__icon-wrapper">
            <segment-icon :segment-key="segment.key"
                          class="summary-segment-item__icon" />
        </div>
        <div class="summary-segment-item__text-wrapper">
            <div class="summary-segment-item__text">
                <span class="summary-segment-item__text__name">{{ segment.text }}</span>
                <span v-if="bulletsLoaded"
                      class="summary-segment-item__text__description">
                    <span class="summary-segment-item__text__description__inner">{{ description }}</span>
                </span>
                <span v-else class="summary-segment-item__text__description --loading">
                    <faux-progress />
                </span>
            </div>
        </div>
    </li>
</template>

<script>

import Vuex from 'vuex'

import FauxProgress from '../app-core/faux-progress'
import SegmentIcon from './segment-icon'

export default {

    props: {
        segment: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {Array}
             */
            bullets: stateStore => stateStore.myHome.summaryBullets,

            /**
             * @param {VuexState} stateStore
             * @returns {?PropertyAsJson}
             */
            property: stateStore => stateStore.property,
        }),

        bulletsLoaded() {
            return this.bullets && this.bullets.length
        },

        description() {
            const linkedBullet = this.bullets.find(bullet => bullet.segmentKey == this.segment.key)
            return linkedBullet ? linkedBullet.displayText : 'Click through to view details'
        },
    },

    components: {
        FauxProgress,
        SegmentIcon,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\my-home\_summary-segment-item.scss

.summary-segment-item {
    display: grid;
    width: 100%;
    grid-template-columns: 60px auto;

    @include element('text-wrapper') {
        @include user-select-none;
    }

    @include element('text') {
        @include element('name') {
            font-weight: bold;
            display: block;

            @include bp-min-wide {
                font-size: 1rem;
            }
        }

        @include element('description') {
            font-size: 0.9rem;

            @include bp-min-small {
                font-size: 0.9rem;
            }

            &.--loading {
                display: block;
            }

            @include element('more-wrapper') {
                white-space: nowrap;
            }
        }
    }
}

</style>
